'use strict';

import React, {useMemo} from 'react';
import {h, Fragment} from 'preact';
import {Link, withRouter} from 'react-router-dom';
import useQuery from '../utility/useQuery';
import _ from 'lodash';
import Paginator from './Pagination/Paginator';

function Pagination(props) {
    const query = useQuery();

    const page = useMemo(() => ~~query.get('start'), [query]);
    const paginator = useMemo(
        () => new Paginator(props.location, props.total, props.perPage, page).setQuery(Array.from(query)),
        [props.total, props.perPage, page, query]
    );

    const elements = useMemo(() => paginator.elements(), [paginator, page]);

    if (!paginator || !paginator.hasPages()) {
        return '';
    }

    return (
        <ul className='pagination'>
            {/*Previous Page Link*/}
            {paginator.onFirstPage() ? (
                <li className='page-item disabled'>
                    <span className='page-link'>&laquo;</span>
                </li>
            ) : (
                <li className='page-item'>
                    <Link to={paginator.previousPageUrl()} className='page-link' rel='prev'>
                        &laquo;
                    </Link>
                </li>
            )}

            {/*Pagination Elements*/}
            {elements.map(element => {
                // "Three Dots" Separator
                if (typeof element === 'string') {
                    return (
                        <li className='page-item disabled' key={element}>
                            <span className='page-link'>{element}</span>
                        </li>
                    );
                } else if (_.isObjectLike(element)) {
                    return _.map(element, item => {
                        if (~~item.page === ~~paginator.currentPage()) {
                            return (
                                <li className='page-item active' key={item.page}>
                                    <span className='page-link'>{item.page}</span>
                                </li>
                            );
                        }

                        return (
                            <li className='page-item' key={item.page}>
                                <Link to={item.url} className='page-link'>
                                    {item.page}
                                </Link>
                            </li>
                        );
                    });
                }
            })}

            {/*Next Page Link*/}
            {paginator.hasMorePages() ? (
                <li className='page-item'>
                    <Link to={paginator.nextPageUrl()} className='page-link' rel='next'>
                        &raquo;
                    </Link>
                </li>
            ) : (
                <li className='page-item disabled'>
                    <span className='page-link'>&raquo;</span>
                </li>
            )}
        </ul>
    );
}

export default withRouter(Pagination);
